import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { ExtractFromLoadService } from '../extract-from-load.service';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { ParamsPopupComponent } from '../params-popup/params-popup.component';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss']
})

export class ParametersComponent implements OnInit {
  instanceList: any;
  selectedInstance: any;
  checked: boolean = true;  
  batchKeyDetails: any;
  public batchKey: string;
  public projectId: string;
  public projectName: string;
  public options: any;
  public tracks = [];
  public configData = [];
  public taskData = [];
  public showArray = [];
  fromTable: any;
  submitBtnEnable: boolean;
  public itemNumber = 2;
  public progressBarName = "parameters";
  public progressBarArray1: any = [
    { name: "select", src: "assets/complete.png", index: 0 },
    { name: "submit", src: "assets/complete.png", index: 1 },
    { name: "parameters", src: 'assets/params.svg', index: 2 },
    { name: "extract", src: 'assets/extract.png', index: 3 }
  ];
  trackNewObj: any = [];
  paramData: any;
  constructor( public dialog: MatDialog, private celService: ExtractFromLoadService,
    private router: Router, private route: ActivatedRoute, private _data: DataService,
    private notification: NotificationService) {  }

  ngOnInit(): void {
    if (this.celService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.getParamsList();
      this.fromTable = this.celService.fromTable;
      this.instanceList = this.celService.instanceList;
      this.selectedInstance = this.celService.instanceName;
      this.batchKeyDetails = this.celService.batchKeyDetails;
      this.batchKey = this.celService.batchKey;
      this.projectId = this.celService.projId;

      if (this.fromTable) {
        this.tracks = this.celService.tracksFromTable;
        this.prepareObjEdit(this.batchKeyDetails);
        this.setShowArrayEdit();
      } else {
        this.tracks = this.celService.configObj?.tracks;
        this.configData = this.celService.configObj?.configData;
        this.prepareObj(this.configData);
        this.setShowArray();
      }
      
    }
    console.log("*********************************************************************************************");
    console.log(this.batchKeyDetails, this.configData);
    console.log("*********************************************************************************************");
  }


  getParamsList(){
    this.maskPage();
    this.celService.getParamsList().subscribe((res) => {
      console.log("res-----------",res);
      this.paramData = res.CloudExtract_LOV;
      this.celService.paramData = res.CloudExtract_LOV;
      this.unMaskPage();
    },
      error => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError('Something went wrong!');
      });
  }




  setShowArray() {
    this.tracks.forEach((val, index) => {
      this.showArray[index] = false;
    });
    this.tracks.forEach((val1, index) => {
      this.configData.forEach((val2, index2) => {
        if (val1 === val2.TRACK && val2.saveStatus) {
          this.showArray[index] = true;
        }
      });
    });
  }

  setShowArrayEdit() {
    this.trackNewObj.forEach((val, index) => {
      this.showArray[index] = true;
    });
    // this.tracks.forEach((val1, index) => {
    //   this.configData.forEach((val2, index2) => {
    //     if (val1 === val2.TRACK && val2.saveStatus) {
    //       this.showArray[index] = true;
    //     }
    //   });
    // });
  }

  prepareObj(configData){
    const obj =[];
    configData?.forEach((ele,i) => {
      if(ele.saveStatus){
        const task = [];
        const track = ele.TRACK;
        if(this.trackNewObj.includes(track)){

        }else{
          this.trackNewObj.push(track);
        }
        ele.TASK.forEach((e)=>{
          if(e.selectStatus ==='y'){
            // e.paramScope = true;
            if(e.paramVal != null && e.paramVal != undefined && e.paramVal?.length >0){
              // e.checked = e.checked;
              // e.paramVal = e.paramVal;
              task.push(e);
            }else{
              e.checked = false;
              e.paramVal = null;
              task.push(e);
            }
          }else{
            task.push(e);
          }
        });
        ele.TASK = task;
        obj.push(ele);
      }
    });
    this.taskData = obj;
    console.log("task obj",this.taskData);
    console.log("this.trackNewObj",this.trackNewObj);
    
  }

  prepareObjEdit(batchDetails){
    const obj =[];
    this.trackNewObj = [];
    batchDetails?.forEach((ele,i) => {
      if(ele.saveStatus){
        const task = [];
        const track = ele.track;
        if(this.trackNewObj.includes(track)){

        }else{
          this.trackNewObj.push(track)
        }
        ele.linedetail.forEach((e)=>{
          if(e.taskselected === "Y"){
            const count = (e.paramVal?.length>0) ? e.paramVal.filter(val => val.value != null).length : e.BUSINESSOBJECT.filter(val => val.value != null).length;
            // e.paramScope = true;
            if(count>0){
              e.checked = true;
              e.paramVal = e.paramVal ? e.paramVal : this.prepareParamValObj(e.BUSINESSOBJECT) ; //null;
              task.push(e);
            }else{
              e.checked = false;
              e.paramVal = e.paramVal ? e.paramVal : null;
              task.push(e);
            }
          }else{
            task.push(e);
          }
        });
        // ele.TASK = task;
        ele.linedetail = task;
        obj.push(ele);
      }
    });
    this.taskData = obj;
    console.log("task obj",this.taskData);
    console.log("this.trackNewObj",this.trackNewObj);    
  }

  prepareParamValObj(businessObj){
      const obj = [];
      businessObj.forEach(e => {
        if(e.value != null){
          // const unitData = this.setParamsValue(e);
          e.scope = true;
          e.params = []; 
        }else{
          e.scope = false;
          e.params = [];
        }     
        obj.push(e);
      });
  return  obj;
  }

  onInstanceChange(instance) { }


  paramsPopup(evt, data,i,application){
    evt.stopPropagation();
    if(data.EXTRACTPARAMETER === "Y"){
    const dialogRef = this.dialog.open(ParamsPopupComponent, {
      width: "927px",
      height: "620px",
      data: Object.assign({}, data),
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.savedData) {
        this.taskData.forEach((ele,ind) => {
          if(ele.APPLICATION === application){
            ele.TASK.forEach((e,index)=>{
              if(index == i){                
                e.paramVal = result.dataObj;
                if(result.dataObj.filter(obj => obj.scope == true).length>0){
                  e.checked = true;
                }else{
                  e.checked = false;
                }
                this.taskData[ind].TASK.splice(index, 1, e);
              }
            });
          }
        });
        console.log("this.taskData",this.taskData);
      }
    });
  }
  }

  paramsPopupEdit(evt, data,i,application){
    evt.stopPropagation();
    if(data.EXTRACTPARAMETER === "Y"){
    const dialogRef = this.dialog.open(ParamsPopupComponent, {
      width: "927px",
      height: "620px",
      data: Object.assign({}, data),
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.savedData) {
        this.taskData.forEach((ele,ind) => {
          if(ele.application === application){
            ele.linedetail.forEach((e,index)=>{
              if(index == i){                
                e.paramVal = result.dataObj;
                if(result.dataObj.filter(obj => obj.scope == true).length>0){
                  e.checked = true;
                }else{
                  e.checked = false;
                }
                this.taskData[ind].linedetail.splice(index, 1, e);
              }
            });
          }
        });
        console.log("this.taskData",this.taskData)
      }
    });
  }
  }

  onSubmitParams() {
    // this.maskPage();
    const body = this.onConfigSubmit();
    this.celService.onConfigParamsSubmit(body).subscribe((res) => {
          this.unMaskPage();
          // this.batchKey = res.Batch_Key;
          // this.celService.batchKey = this.batchKey;
          if (res.Result === "SUCCESS") {
            const dialogRef = this.dialog.open(InfoPopupComponent, {
              width: "917px",
              height: "220px",
              data: {
                type: "Task Status",
                mess: `Batch Key ${this.batchKey}  <b>: New - Parameters Submitted</b> `
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result === "ok" || result === "") {
                const dat = this.fromTable ? "" :this.celService.configObj.configData = this.configData;
                // this.maskPage();               
                  this.celService.tabval.next("extract");
                  this.router.navigate(["../extract"], { relativeTo: this.route });                
              }
            });
          } else {
            alert(res.Result);
          }
        },
          (error) => {
            this.unMaskPage();
            this.notification.showError('Something went wrong!');
          });
  }

  onConfigSubmit() {
    let body;
    if (this.fromTable) {
      body = {
        batchkey: this.batchKeyDetails[0].batchkey,
        projectname: this.batchKeyDetails[0].projectname,
        // projectname: 'TestProj1',
        requestedby: this.batchKeyDetails[0].requestedby,
        filesharepath: this.batchKeyDetails[0].filesharepath,
        requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Extract,//"EXTRACT",
        extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,//"SQL",
        instanceid: this.selectedInstance.INSTANCE_ID.toString(),
        LineItems: this.getLineItemsEdit(this.batchKeyDetails)
      };
    } else {
      body = {
        batchkey: this.celService.batchKey ? this.celService.batchKey : "",
        projectname: this.projectId,
        requestedby: this.celService.requestedBy,
        filesharepath: this.celService.getfileSharePath(),//"\\\\usazuconde00173\\DFTE\\",
        requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Extract,//"EXTRACT",
        extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,//"SQL",
        instanceid: this.selectedInstance.INSTANCE_ID.toString(),
        LineItems: this.getLineItems(this.configData)
      };
    }

    return body;
  }

  getLineItems(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.TASK != null && element.saveStatus) {
        element.TASK.forEach((ele) => {
          if (ele.selectStatus === "y") {

            const businessObjectData = ele.paramVal == null ? this.getBusinessObjectData(ele.BUSINESSOBJECT) : this.getBusinessObjectData(ele.paramVal);
            const trackObj = {
              TRACK: element.TRACK,
              APPLICATION_SHORT_CODE: element.APPLICATION_SHORT_CODE,
              TASK_NAME: ele.TASK_NAME,
              TASK_CODE: ele.TASK_CODE,
              RUN_LINE_ID: '',
              RUN_HEADER_ID:this.celService.batchKeyDetails[0].runheaderid,
              BUSINESSOBJECT1: businessObjectData[0].nameCode,
              PARAMETERVALUE1: businessObjectData[0].paramVal,
              BUSINESSOBJECT2: businessObjectData[1].nameCode,
              PARAMETERVALUE2: businessObjectData[1].paramVal,
              BUSINESSOBJECT3: businessObjectData[2].nameCode,
              PARAMETERVALUE3: businessObjectData[2].paramVal,
              BUSINESSOBJECT4: businessObjectData[3].nameCode, 
              PARAMETERVALUE4: businessObjectData[3].paramVal, 
              BUSINESSOBJECT5: businessObjectData[4].nameCode, 
              PARAMETERVALUE5: businessObjectData[4].paramVal, 
              BUSINESSOBJECT6: businessObjectData[5].nameCode, 
              PARAMETERVALUE6: businessObjectData[5].paramVal, 
              BUSINESSOBJECT7: businessObjectData[6].nameCode, 
              PARAMETERVALUE7: businessObjectData[6].paramVal, 
              BUSINESSOBJECT8: businessObjectData[7].nameCode, 
              PARAMETERVALUE8: businessObjectData[7].paramVal,
              BUSINESSOBJECT9: businessObjectData[8].nameCode, 
              PARAMETERVALUE9: businessObjectData[8].paramVal, 
              BUSINESSOBJECT10: businessObjectData[9].nameCode, 
              PARAMETERVALUE10: businessObjectData[9].paramVal
            };
            data.push(trackObj);
          }
        });
      }
    });
    const objData = this.getrunLineId(this.batchKeyDetails, data);
    return objData;
  }


  getrunLineId(batchKeyDetails,dataObj){
    const obj =  batchKeyDetails.filter(ele => ele.saveStatus == true);
    const tempDataObj = dataObj.slice();

    dataObj.forEach((ele,i) => {
      const filterVal = obj.filter(e => (ele.APPLICATION_SHORT_CODE == e.applicationshortcode));
      console.log("filterVal------------",filterVal);
      filterVal[0].linedetail.every(val =>{
        if(ele.TASK_CODE == val.taskcode ){
          tempDataObj[i].RUN_LINE_ID = val.runlineid;
          return false;
        }
        console.log("val------------",val);
        return true;
      });
    });
    return tempDataObj;
  }

  getBusinessObjectData(obj){
    const buobj = [];
    obj.forEach((ele,i) => {
      if(ele.scope == undefined && (ele.name == null || ele.name == "" )){
        const objData = {
          nameCode : "",
          paramVal : ""
        };
        buobj.push(objData);
        return;
      }else if(ele.scope == undefined && ele.name != null && ele.name != "" ){
        const objData = {
          nameCode : ele.code,
          paramVal : ""
        };
        buobj.push(objData);
        return;
      }else if(ele.scope == false && (ele.name == null || ele.name == "" )){
        const objData = {
          nameCode : "",
          paramVal : ""
        };
        buobj.push(objData);
        return;
      }else if(ele.scope == false && ele.name != null && ele.name != "" ){
        const objData = {
          nameCode : ele.code,
          paramVal : ""
        };
        buobj.push(objData);
        return;
      }else if(ele.scope && ele.params?.length>0 ){
        const params = ele.params;
        const val = []
        params.forEach(e => {
          if(e.checkVal){
            // val.push(e.id != null ? e.id : e.businessname);
            val.push(e.id != null ? e.id : e.businessobjectcode1 != null ? e.businessobjectcode1 : e.businessname);
          }
        });
        const objData = {
          nameCode : ele.code,
          paramVal : val.join('|')
        };
        buobj.push(objData);
        return;
      }else if(ele.scope && ele.params?.length==0 ){     
        const objData = {
          nameCode : ele.code,
          paramVal : ele.value
        };
        buobj.push(objData);
        return;
      }else{
        const objData = {
          nameCode : "",
          paramVal : ""
        };
        buobj.push(objData);
      }
    });
    return buobj;
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  unMaskPage() {
    this._data.apiCallInProgress = false;
    document.getElementById("overlay").style.display = "none";
  }

  getLineItemsEdit(batchKeyDetails) {
      const data = [];
      batchKeyDetails?.forEach((element) => {
        if (element.linedetail != null && element.saveStatus) {
          element.linedetail.forEach((ele) => {
            if (ele.taskselected === "Y") {
  
              const businessObjectData = ele.paramVal == null ? this.getBusinessObjectData(ele.BUSINESSOBJECT) : this.getBusinessObjectData(ele.paramVal);
              const trackObj = {
                TRACK: element.track,
                APPLICATION_SHORT_CODE: element.applicationshortcode,
                TASK_NAME: ele.taskname,
                TASK_CODE: ele.taskcode,
                // RUN_LINE_ID: ele.runlineid,
                RUN_LINE_ID: '',
                RUN_HEADER_ID: this.celService.batchKeyDetails[0].runheaderid,
                BUSINESSOBJECT1: businessObjectData[0].nameCode,
                PARAMETERVALUE1: businessObjectData[0].paramVal,
                BUSINESSOBJECT2: businessObjectData[1].nameCode,
                PARAMETERVALUE2: businessObjectData[1].paramVal,
                BUSINESSOBJECT3: businessObjectData[2].nameCode,
                PARAMETERVALUE3: businessObjectData[2].paramVal,
                BUSINESSOBJECT4: businessObjectData[3].nameCode, 
                PARAMETERVALUE4: businessObjectData[3].paramVal, 
                BUSINESSOBJECT5: businessObjectData[4].nameCode, 
                PARAMETERVALUE5: businessObjectData[4].paramVal, 
                BUSINESSOBJECT6: businessObjectData[5].nameCode, 
                PARAMETERVALUE6: businessObjectData[5].paramVal, 
                BUSINESSOBJECT7: businessObjectData[6].nameCode, 
                PARAMETERVALUE7: businessObjectData[6].paramVal, 
                BUSINESSOBJECT8: businessObjectData[7].nameCode, 
                PARAMETERVALUE8: businessObjectData[7].paramVal,
                BUSINESSOBJECT9: businessObjectData[8].nameCode, 
                PARAMETERVALUE9: businessObjectData[8].paramVal, 
                BUSINESSOBJECT10: businessObjectData[9].nameCode, 
                PARAMETERVALUE10: businessObjectData[9].paramVal
              }
              data.push(trackObj);
            };
          });
        }
      });
      const objData = this.getrunLineId(this.celService.UpdatedbatchKeyDetails, data);
      return objData;
      // let objData = data;
      // return objData;
    }

}
